import { JSX } from 'react';
import { ButtonSize, ButtonType, IconButton } from '@ardoq/button';
import { space } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import { type I18nLocale, t } from '@ardoq/i18n';
import styled from 'styled-components';

const Icon = styled(IconButton)`
  position: absolute;
  top: ${space.small};
  right: ${space.small};
`;

type ExpandButtonProps = {
  i18nLocale: I18nLocale;
  isExpanded: boolean;
  onToggleExpand: VoidFunction;
  collapseLabel?: string;
  expandLabel?: string;
};

export function ExpandButton({
  i18nLocale,
  isExpanded,
  onToggleExpand,
  collapseLabel = t(
    i18nLocale,
    'integrations:expandButton.collapse',
    'Collapse'
  ),
  expandLabel = t(i18nLocale, 'integrations:expandButton.expand', 'Expand'),
}: ExpandButtonProps): JSX.Element {
  return (
    <Icon
      buttonType={ButtonType.GHOST}
      buttonSize={ButtonSize.SMALL}
      onClick={onToggleExpand}
      iconName={isExpanded ? IconName.FULLSCREEN_EXIT : IconName.FULLSCREEN}
      label={isExpanded ? collapseLabel : expandLabel}
    />
  );
}
